import React, { ChangeEvent } from "react";
import styles from "./input-with-toggle.module.scss";
import { ToggleButton } from "../toggle-button/toggle-button";
import { DashboardEditWidgetDrawerDropdown } from "../dashboard-edit-widget-drawer-dropdown/dashboard-edit-widget-drawer-dropdown";
import { NameAndSourceId } from "@common/types/server-list-types";

const cssClassName = "input-with-toggle";

interface InputWithTogglePropTypes {
  labelText: string;
  /** Sits next to the switch, so the switch says what it switches the field to. */
  toggleText: string;
  /** True = the field is driven by an OPC-UA node: the switch reads active and
   *  the node picker takes the number input's place. */
  isNodeMode: boolean;
  handleToggleClick: () => void;
  nodeOptions: NameAndSourceId[];
  selectedNode: NameAndSourceId | null;
  onSelectNode: (node: NameAndSourceId | null) => void;
  noNodesText: string;
  nodesPlaceholderText: string;
  isLoadingNodes: boolean;
  inputPlaceHolder: string;
  inputValue: string | number;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

/**
 * A number field whose value can come from a typed number or from an OPC-UA
 * node. The switch on the label row decides which; it stays put in both states
 * so the field can always be switched back.
 */
export const InputWithToggle = ({
  labelText,
  toggleText,
  isNodeMode,
  handleToggleClick,
  nodeOptions,
  selectedNode,
  onSelectNode,
  noNodesText,
  nodesPlaceholderText,
  isLoadingNodes,
  inputPlaceHolder,
  inputValue,
  onInputChange,
}: InputWithTogglePropTypes) => (
  <div className={styles[`${cssClassName}__label`]}>
    <span className={styles[`${cssClassName}__label-row`]}>
      {labelText}
      <span className={styles[`${cssClassName}__toggle`]}>
        <ToggleButton isActive={isNodeMode} handleClick={handleToggleClick} />
        {toggleText}
      </span>
    </span>
    {isNodeMode ? (
      <DashboardEditWidgetDrawerDropdown
        options={nodeOptions}
        selectedOption={selectedNode}
        onSelectOption={onSelectNode}
        noOptionsText={noNodesText}
        placeholderText={nodesPlaceholderText}
        isLoading={isLoadingNodes}
      />
    ) : (
      <input
        type="text"
        placeholder={inputPlaceHolder}
        value={inputValue}
        onChange={onInputChange}
        className={styles[`${cssClassName}__input`]}
      />
    )}
  </div>
);
